import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
export const VoiceToVoiceModalLoader = React.memo(function VoiceToVoiceModalLoader() {
    return (_jsx("div", { className: "bg-base fixed inset-0 z-[999] flex h-screen w-screen items-center justify-center opacity-50" }));
});
//# sourceMappingURL=VoiceToVoiceModalLoader.js.map